import { DiscountType } from "../types/discounts";
import { formatCurrency } from "./cashDrawerUtils";
import { getLineDiscountEntries, LineWithDiscounts } from "./lineItemDiscounts";

/**
 * Human-readable value of a discount: "10%" / "2.91%" for a percentage,
 * "$5.00" (via formatCurrency) for a fixed amount. Percentages keep up to two
 * decimals and drop trailing zeros.
 */
export function formatDiscountValue(
  type: DiscountType | string | null | undefined,
  amount: number,
): string {
  if (type === "Percentage") {
    return `${Number(amount.toFixed(2))}%`;
  }
  return formatCurrency(amount);
}

/** "10% off" / "$5.00 off" — a discount's value as a caption. */
export function formatDiscountOff(
  type: DiscountType | string | null | undefined,
  amount: number,
): string {
  return `${formatDiscountValue(type, amount)} off`;
}

/** "Birthday 20%" / "Loyalty $5.00" — the label used on chips and rows. */
export function formatDiscountLabel(
  name: string,
  type: DiscountType | string | null | undefined,
  amount: number,
): string {
  return `${name} ${formatDiscountValue(type, amount)}`;
}

/**
 * One chip label per discount on a line ("Birthday 20%", "Loyalty $5.00"), in
 * application order.
 */
export function getLineDiscountLabels(line: LineWithDiscounts): string[] {
  return getLineDiscountEntries(line).map((entry) =>
    formatDiscountLabel(entry.name, entry.discount_type, entry.amount),
  );
}
